import React from 'react';
import { Field, withFormik, FormikProps } from 'formik';
import * as yup from 'yup';
import { InputField } from '@/components/formFields/InputField';
import { Button } from '@/components/ui/Button';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight, ArrowLeft } from 'lucide-react';

interface ResetPasswordEmailFormValues {
  email: string;
}

interface ResetPasswordEmailFormOuterProps {
  submit: (values: ResetPasswordEmailFormValues) => Promise<Record<string, string> | undefined>;
  errorFromServer?: string;
}

type ResetPasswordEmailFormInnerProps = FormikProps<ResetPasswordEmailFormValues> &
  ResetPasswordEmailFormOuterProps;

class C extends React.Component<ResetPasswordEmailFormInnerProps> {
  render() {
    const { values, handleSubmit, errors, touched } = this.props;
    return (
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="space-y-1.5">
          <label className="text-[11px] font-medium uppercase tracking-wider text-neutral-600 inline-block">
            E-mail
            <span className="text-danger ml-1">*</span>
          </label>
          <div className="relative">
            <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
            <Field
              name="email"
              value={values.email}
              placeholder="jmeno@spolecnost.cz"
              component={InputField}
              data-testid="reset-password-email-input"
              className="pl-9"
            />
          </div>
        </div>

        <Button type="submit" size="lg" className="w-full" data-testid="reset-password-submit-btn">
          Potvrdit
          <ArrowRight size={14} />
        </Button>

        <div className="flex justify-center">
          <Link
            to="/login"
            className="text-sm text-neutral-500 hover:text-neutral-700 inline-flex items-center gap-1.5 transition-colors"
          >
            <ArrowLeft size={14} />
            Zpět na přihlášení
          </Link>
        </div>
      </form>
    );
  }
}

const validationSchema = yup.object({
  email: yup.string().email('Zadejte validní e-mail').required('Povinné pole'),
});

const ResetPasswordEmailForm = withFormik<
  ResetPasswordEmailFormOuterProps,
  ResetPasswordEmailFormValues
>({
  validationSchema,
  mapPropsToValues: () => ({ email: '' }),
  handleSubmit: async (values, { props, setErrors }) => {
    const errors = await props.submit(values);
    if (errors) {
      setErrors(errors);
    }
  },
})(C);

export default ResetPasswordEmailForm;
